
import * as React from 'react';

export const Undo = ({ className, color = '#333333', size = '24px' }) => /*#__PURE__*/
React.createElement("svg", {

  className: className,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.09524 3.28101C9.49233 3.66486 9.50306 4.29794 9.11921 4.69502L7.35773 6.51724H15.9277C19.4587 6.51724 21.2578 10.7586 18.8036 13.2973L10.6859 21.695C10.302 22.0921 9.66895 22.1028 9.27186 21.719C8.87478 21.3351 8.86405 20.7021 9.2479 20.305L17.3657 11.9073C18.5927 10.6379 17.6932 8.51724 15.9277 8.51724H7.35773L9.11921 10.3395C9.50306 10.7365 9.49233 11.3696 9.09524 11.7535C8.69815 12.1373 8.06508 12.1266 7.68123 11.7295L3.60938 7.51724L7.68123 3.30498C8.06508 2.90789 8.69815 2.89716 9.09524 3.28101Z",
  fill: color }));